import { Color, DefaultValue, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { PERIOD_DROPDOWN_WIDTH } from '../../constants/periodDropdownWidth'

export const PeriodDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${PERIOD_DROPDOWN_WIDTH}px;
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('elevatedStrong')}
`

export const ScrollableWrapper = styled.div`
  padding: ${Spacing.S16} ${Spacing.S16} ${Spacing.S8};
  overflow: auto;
`

export const FooterWrapper = styled.footer`
  padding: ${Spacing.S8} ${Spacing.S16} ${Spacing.S16};
`
